import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types';
import renderIf from 'render-if';
import Button from 'components/CustomButton';
import Error from 'components/ErrorMessage';
import UserInfo from '../../../Userinfo/index';
import styles from '../StudentEvaluation/styles.scss';

// to import local scss fle

class ResetDashboard extends Component {
  static propTypes = {
    userInfo: PropTypes.shape.isRequired,
    setTabToInitial: PropTypes.func.isRequired,
    resetStudentDashboard: PropTypes.func.isRequired,
    dashboardReset: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { userInfo, setTabToInitial, dashboardReset } = this.props;
    // const { showError } = this.state;
    const renderUserNotSelected = renderIf(userInfo.name === undefined);
    const renderUserSelected = renderIf(userInfo.name !== undefined);
    const renderSuccessMessage = renderIf(dashboardReset && userInfo.name !== undefined);
    return (
      <div className={cn('col s12', styles.removePadding)}>
        {renderUserNotSelected(<Error message="Please select user in first tab" />)}
        {renderUserSelected(
          <div className={cn('col s12', styles.container)}>
            <UserInfo userInfo={userInfo} userType="STUDENT" /><br />
          </div>)}
        {renderUserSelected(
          <div className={cn('col s12', styles.actionContainer)}>
            <Button
              label="RESET ABOVE STUDENT"
              style={styles.buttonContainer}
              onClick={() => this.props.resetStudentDashboard(userInfo.id)}
            />
          </div>,
            )}
        {renderUserNotSelected(<Button label="SELECT USER" style={styles.buttonContainer} onClick={setTabToInitial} />)}
        {renderSuccessMessage(
          <span>
            <span className={styles.successMessage}>Student dashboard has been reset.</span>
          </span>,
         )}
      </div>
    );
  }
}

export default ResetDashboard;



// WEBPACK FOOTER //
// ./src/containers/Admin/components/StudentView/components/ResetDashboard/ResetDashboard.js